// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"4dc2becf","272":"400051e8","960":"1d566039"}[chunkId] + ".js";
};